import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@printdeal/ui-library';
import { getPickupPointHref } from '@printdeal/business-logic';

import PickupPointDetails from '../../../../pickup-points/PickupPointDetails';
import { SanitizedLineItem } from '../../../../../types/order/Order';

interface LineItemPickupPointProps {
  lineItem: SanitizedLineItem;
}

const LineItemPickupPoint = ({ lineItem }: LineItemPickupPointProps) => (
  <Grid className="pd-grid-cols-[1fr,2fr] pd-gap-4">
    <Grid.Item>
      <FormattedMessage
        id="pickupPointDetails.pickupPoint"
        defaultMessage="Pickup point"
      />:
    </Grid.Item>
    <Grid.Item>
      <PickupPointDetails
        href={getPickupPointHref(lineItem) || ''}
        showLabel={false}
        errorMessage={(
          <FormattedMessage
            id="pickupPointDetails.error.orderDetail"
            defaultMessage="Could not fetch pickup point details. If the problem persists, please contact customer service."
          />
        )}
      />
    </Grid.Item>
  </Grid>
);

export default LineItemPickupPoint;
